import styled, { css } from 'styled-components';

import BamOnlineLink from 'components/b2c/BamOnlineLink';
import { fontFamily } from 'stylesheet';
import {
  addVeryWideDesktopDesignStyle,
  colorUsage,
  fontSize,
  fontWeight,
  getSpacing,
  lineHeight,
} from 'stylesheetB2c';

export const OfferLink = styled(BamOnlineLink)`
  width: ${getSpacing(34)};
  font-size: ${fontSize.XSmall};
  height: ${getSpacing(6)};
  font-weight: ${fontWeight.bold};
`;
OfferLink.displayName = 'OfferLink';

export const MessageText = styled.p`
  font-family: ${fontFamily.bamOnline};
  font-size: ${fontSize.XXLarge};
  line-height: ${lineHeight.XLarge};
  color: ${colorUsage.webPlayer.messageText};
  font-weight: ${fontWeight.light};
  text-align: center;
  ${addVeryWideDesktopDesignStyle(css`
    font-size: ${fontSize.XXXLarge};
  `)}
`;
MessageText.displayName = 'MessageText';
